export default __webpack_public_path__ + "static/media/wallet.67c83d6b.svg";